var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2364,
    height: 1046,
    transform: "translate(-576 -362)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6817 17.6419L18.3517 5.64853L6.34166 10.3059L10.3117 12.0949C10.3586 12.1164 10.405 12.1389 10.4506 12.1625C10.4891 12.1023 10.5346 12.0453 10.5872 11.9928L12.5883 9.99277C12.9788 9.60246 13.612 9.60246 14.0025 9.99277C14.393 10.3831 14.393 11.0159 14.0025 11.4062L12.0014 13.4062C11.948 13.4596 11.8901 13.5057 11.8288 13.5444C11.8507 13.5871 11.8716 13.6303 11.8917 13.6741L13.6817 17.6419ZM19.4317 3.07996C19.5717 3.02998 19.7117 3 19.8517 3H19.8617C20.6217 3 21.2317 3.77957 20.9217 4.56913L14.8117 20.2704C14.6217 20.7501 14.1817 21 13.7417 21C13.3217 21 12.9017 20.7701 12.7017 20.3204L10.0817 14.4936C9.96166 14.2338 9.76166 14.0239 9.50166 13.9139L3.67166 11.2954C2.75166 10.8856 2.78166 9.55635 3.73166 9.18656L19.4317 3.07996Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon-send.9954308d134632980519548c02a7158c.svg";
export { ForwardRef as ReactComponent };